import React from "react";
import "./Footer.css";
import Logo from "../../assets/PROTAL_LOGO3.svg"

const Footer = () => {
  return (
    <>
      <div className="footer-body">
        <div className="logo non-selectable">
          <img alt="Protal Logo" src={Logo} className="logo-img"/>
        </div>
        <div className="nav-body">
          <div className="nav-link">
            <p>
              <a href="#features">Features</a>
            </p>
          </div>
          <div className="nav-link">
            <p>
              <a href="#about">About Us</a>
            </p>
          </div>
          <div className="nav-link">
            <p>
              <a href="#faq">FAQs</a>
            </p>
          </div>
          <div className="nav-link">
            <p>
              <a href="#contact">Contact Us</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
